import { Injectable } from '@angular/core'
import { HttpService } from '@bases/http.service'
import { API_URL } from '@core/constants/constant.data'

@Injectable()
export class FeedbackService extends HttpService {
  protected _baseUrl = API_URL + '/users/feedback'

  sendFeedback(data: FormData) {
    return this.POST(data, API_URL + '/users/feedback')
  }
}
